let cachedConfiguration = null

export function setLiveConfigurationCache(configuration) {
  cachedConfiguration = configuration
}

export function getLiveConfigurationCache() {
  return cachedConfiguration
}
